import React from "react"
import { useAdvancedSearchMCMutation } from "../../core/api/mc-state-api"
import MultiSearch from "./MultiSearch"

export default function SearchBarTOH() {
    return <MultiSearch useSearchHook={useAdvancedSearchMCMutation}/>
}
